<template>
	<page>
		<module title="补贴详情" height="auto">
			<c-detail >
				<c-detail-item label="订单号" >
					{{orderDetail.order_number}}
				</c-detail-item>
				<c-detail-item label="状态" >
					<template v-slot="{data}">
						<span v-if="orderDetail.state==1" style="color:darkgreen">正常</span>
						<span v-if="orderDetail.state==2" style="color:brown">订单退款</span>
						<span v-if="orderDetail.state==3" style="color:darkgray">订单退货</span>
						<span v-if="orderDetail.state==4" style="color:red">清单取消</span>
					</template>
				</c-detail-item>
				<c-detail-item label="下单用户" >
					{{orderDetail.nick_name}}
					<span v-if="orderDetail.user_manage_mobilephone">
						({{orderDetail.user_manage_mobilephone}})
					</span>
				</c-detail-item>

				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="商品名称" >
					{{orderDetail.product_name}}
				</c-detail-item>
				<c-detail-item label="商品规格" >
					{{orderDetail.product_sku_spec}}
				</c-detail-item>
				<c-detail-item label="商品数量" >
					{{orderDetail.product_count}}
				</c-detail-item>
				<c-detail-item label="补贴类型" >
					<template v-slot="{data}">
						<span v-if="orderDetail.type==1">优惠券</span>
					</template>
				</c-detail-item>
				<c-detail-item label="补贴金额" full>
					<template v-slot="{data}">
						{{'¥'+parseFloat(orderDetail.money).toFixed(2)}}
						<span v-if="orderDetail.cancel_money >0 && data.state != 4" style="color: darkgray">(已取消 {{'¥'+parseFloat(orderDetail.cancel_money).toFixed(2)}})</span>
					</template>
				</c-detail-item>
				<c-detail-item label="备注" full>
					<span v-if="orderDetail.remark">{{orderDetail.remark}}</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'subsidy_record_detail',
		props: {
			orderId: String
		},
		data() {
			return {
				transStateName: {
					4: '取消结算',
					1: '待结算',
					2: '部分结算',
					3: '全部结算'
				},
				state: [{
					name: '待清分',
					value: 1
				},{
					name: '部分结算',
					value: 2
				},{
					name: '全部结算',
					value: 3
				},{
					name: '取消结算',
					value: 4
				}],
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '赠品',
					4: '砍价',
					5: '预定全款',
					6: '预定定金',
					7: '定制'
				},
				orderDetail: {},
				settlementList: [],
				returnList: []
			}
		},
    watch:{//ID变更刷新页面
      orderId(){
        this.detail();
      }
    },
		mounted() {
			this.detail();
		},
		computed: {

		},
		methods: {
			detail() {
				this.request({
					url: '/subsidy/record/detail',
					data: {id: this.orderId},
					loading: true,
					success: data => {
						this.orderDetail = data;
					}
				});
			}
		}
	}
</script>